export const orderDetailDisplayPage = {
  ESTIMATES: "Estimates",
  EDIT_ORDER: "EditOrder",
  REJECT_ESTIMATE: "RejectEstimate",
  ACCEPT_ESTIMATE: "AcceptEstimate",
  CANCEL_REQUEST: "CancelRequest",
  SHARE_ESTIMATES: "ShareEstimates",
} as const;

export type OrderDetailDisplayPage = (typeof orderDetailDisplayPage)[keyof typeof orderDetailDisplayPage];
